<nav class="nxe-tree" [attr.aria-label]="'filemanager.ui.folders' | translate">
  @if (buttonHome$ | async) {
    <ng-container *ngTemplateOutlet="homeTmp"> </ng-container>
  }
  @if (tree$ | async; as tree) {
    <ng-container *ngTemplateOutlet="treeTmp; context: { nodes: tree }"></ng-container>
  }
</nav>

<ng-template #homeTmp>
  <ul class="nxe-tree-ul__home">
      <li>
          <div class="item" role="button" tabindex="0" (click)="home()" (keydown.enter)="home()"
               [ngClass]="{ selected: (selectedId$ | async) === (rootId$ | async) }">
              <span class="chevron-spacer" aria-hidden="true"></span>
              <div class="dir-icon">
                <i-tabler class="icon-18 icon-home" name="files"></i-tabler>
              </div>
              <div class="dir-name">{{ 'filemanager.ui.all_documents' | translate }}</div>
          </div>
      </li>
  </ul>
</ng-template>

<ng-template #treeTmp let-nodes="nodes">
  @if (nodes && nodes.length > 0) {
    <ul class="nxe-tree-ul">
      @for (node of nodes; track $index) {
        @if (!node.isLeaf) {
          <li>
            <div class="item" role="button" tabindex="0" (click)="open(node)" (keydown.enter)="open(node)"
                 [ngClass]="{ selected: (selectedId$ | async) === node.id, archive: isArchiveRoot(node) }"
                 [title]="node.name | nxeFolderName"
                 cdkDropList (cdkDropListDropped)="onDrop($event, node)">
              @if (!node.expanded) {
                <button type="button" class="chevron" (click)="expand($event, node)" (keydown.enter)="$event.stopPropagation()"
                        [attr.aria-label]="'filemanager.ui.expand' | translate" [attr.aria-expanded]="false">
                  <i-tabler class="icon-16" name="chevron-right"></i-tabler>
                </button>
              } @else {
                <button type="button" class="chevron" (click)="collapse($event, node)" (keydown.enter)="$event.stopPropagation()"
                        [attr.aria-label]="'filemanager.ui.collapse' | translate" [attr.aria-expanded]="true">
                  <i-tabler class="icon-16" name="chevron-down"></i-tabler>
                </button>
              }
              <div class="dir-icon">
                <i-tabler class="icon-18 nxe-folder-glyph" name="folder"></i-tabler>
              </div>
              <div class="dir-name">{{ node.name | nxeFolderName }}</div>
            </div>
            @if (node.expanded) {
              <ng-container *ngTemplateOutlet="treeTmp; context: { nodes: node.children }"></ng-container>
            }
          </li>
        }

        @if (node.isLeaf && showFileTree) {
          <li>
            <div class="item" (click)="select(node)" [ngClass]="{ selected: (selectedId$ | async) === node.id }" cdkDrag>
              <span class="chevron-spacer" aria-hidden="true"></span>
              <div class="dir-icon">
                <i-tabler class="icon-18" name="file"></i-tabler>
              </div>
              <div class="dir-name">{{ node.name }}</div>
            </div>
          </li>
        }

      }

    </ul>
  }
</ng-template>
